import { fromJS } from 'immutable';

export const FUEL_LEVEL_VALUES = [
  {
    id: 'empty',
    value: 0,
    renderedValue: { translationId: 'fuelLevel.empty' },
  },
  {
    id: '1/8',
    value: 1,
    renderedValue: '1/8',
  },
  {
    id: '1/4',
    value: 2,
    renderedValue: '1/4',
  },
  {
    id: '3/8',
    value: 3,
    renderedValue: '3/8',
  },
  {
    id: '1/2',
    value: 4,
    renderedValue: '1/2',
  },
  {
    id: '5/8',
    value: 5,
    renderedValue: '5/8',
  },
  {
    id: '3/4',
    value: 6,
    renderedValue: '3/4',
  },
  {
    id: '7/8',
    value: 7,
    renderedValue: '7/8',
  },
  {
    id: 'full',
    value: 8,
    renderedValue: { translationId: 'fuelLevel.full' },
  },
];

export const FUEL_LEVEL_VALUES_V2 = [
  {
    id: 'empty',
    value: 0,
    label: { translationId: 'fuelLevel.empty' },
  },
  {
    id: '1/8',
    value: 1,
    label: '1/8',
  },
  {
    id: '1/4',
    value: 2,
    label: '1/4',
  },
  {
    id: '3/8',
    value: 3,
    label: '3/8',
  },
  {
    id: '1/2',
    value: 4,
    label: '1/2',
  },
  {
    id: '5/8',
    value: 5,
    label: '5/8',
  },
  {
    id: '3/4',
    value: 6,
    label: '3/4',
  },
  {
    id: '7/8',
    value: 7,
    label: '7/8',
  },
  {
    id: 'full',
    value: 8,
    label: { translationId: 'fuelLevel.full' },
  },
];

export const FUEL_LEVEL_DROPDOWN_VALUES = fromJS(FUEL_LEVEL_VALUES);

export const FUEL_LEVEL_TRANSLATIONS = FUEL_LEVEL_VALUES.reduce(
  (accumulator, item) => ({
    ...accumulator,
    [String(item.value)]: item.renderedValue,
  }),
  {}
);

export const FUEL_LEVEL_DELTA_TRANSLATIONS = {
  ...FUEL_LEVEL_TRANSLATIONS,
  0: '0',
  8: '8/8',
};

const _FUEL_LEVEL_DELTA_VALUES_V2 = [...FUEL_LEVEL_VALUES_V2];
_FUEL_LEVEL_DELTA_VALUES_V2[0] = {
  ..._FUEL_LEVEL_DELTA_VALUES_V2[0],
  label: { translationId: 'none' },
};
_FUEL_LEVEL_DELTA_VALUES_V2[8] = {
  ..._FUEL_LEVEL_DELTA_VALUES_V2[8],
  label: '8/8',
};

export const FUEL_LEVEL_DELTA_VALUES_V2 = [..._FUEL_LEVEL_DELTA_VALUES_V2];
